import React from "react"

const MtIconWhite = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="4" y="11" width="16" height="2" rx="1" fill="white" />
      <circle cx="5" cy="17" r="4.5" fill="white" stroke="var(--theme-green)" />
      <circle
        cx="19"
        cy="17"
        r="4.5"
        fill="white"
        stroke="var(--theme-green)"
      />
      <circle
        cx="12"
        cy="17"
        r="5.5"
        fill="white"
        stroke="var(--theme-green)"
      />
      <rect x="4" y="3" width="16" height="2" rx="1" fill="white" />
      <rect x="4" y="7" width="16" height="2" rx="1" fill="white" />
    </svg>
  )
}

export default MtIconWhite
